interface LogoProps {
  size?: number;
}

/**
 * Recipe Keeper mark: a lidded cooking pot with rising steam.
 * Strokes use currentColor, so it inherits the accent from its parent
 * (.logo is colored with --color-primary) and follows theme changes.
 * Keep in sync with public/favicon.svg, which uses the same paths.
 */
export function Logo({ size = 24 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M7 15h18v6a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5v-6z" />
      <path d="M10 15c0-2.5 2.7-4 6-4s6 1.5 6 4" />
      <path d="M4 18h3" />
      <path d="M25 18h3" />
      <path d="M13 3c-1 2 1 3.5 0 5.5" />
      <path d="M19 3c-1 2 1 3.5 0 5.5" />
    </svg>
  );
}
